import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectBrands, loadBrands } from '../features/brands/brandSlice';
import { useGetBrandsQuery } from '../features/brands/brandsApiSlice';

const useBrand = () => {
  const dispatch = useDispatch();
  const brandsFromStore = useSelector(selectBrands);
  
  // Only trigger query if store is empty
  const { data: brandsFromApi, isLoading, error } = useGetBrandsQuery(undefined, {
    skip: brandsFromStore.length > 0
  });

  useEffect(() => {
    // If we got data from API and store is still empty, update store
    if (brandsFromApi && brandsFromStore.length === 0) {
      dispatch(loadBrands(brandsFromApi));
    }
  }, [brandsFromApi, brandsFromStore.length, dispatch]);

  return {
    brands: brandsFromStore.length > 0 ? brandsFromStore : (brandsFromApi || []),
    isLoading: brandsFromStore.length === 0 && isLoading,
    error
  };
};

export default useBrand;